import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { InvoiceService } from '@app/core/services/invoice.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';

@Injectable({ providedIn: 'root' })
export class CanCancelInvoiceProcessResolver  {
  constructor(
    private invoiceService: InvoiceService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const id: string = route.params.id;
    const invoiceViewType: InvoiceViewType = route.params.invoiceViewType;

    let canCancelCall$ = this.invoiceService.canCancelInvoiceProcess(id);
    if (invoiceViewType === InvoiceViewType.VOUCHERVALIDATED) {
      canCancelCall$ = this.invoiceService.canCancelVoucherProcess(id);
    }

    return canCancelCall$
      .pipe(map((_: any) => {
        return true;
      }),
      catchError(_ => {
        return of(false);
      }));
  }
}
